import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StyleType} from "@catui/types";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {isNullOrUndefined} from "util";
import {NetworkInterface} from "@catmodules/models/network-interfaces/types";
import {NotificationsService} from "@catcore/services";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {GenericResourceApiService} from "@catfeatures/services/generic-resource-api.service";
import {NetworkInterfaceService} from "@catmodules/models/network-interfaces/services/network-interface.service";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {FeatureNetworkInterfaceService} from "@catmodules/models/network-interfaces/services/feature-network-interface.service";

@Component({
  selector: 'catapp-modify-network-if',
  templateUrl: './modify-network-if.component.html',
  styleUrls: ['./modify-network-if.component.scss']
})
export class ModifyNetworkIfComponent implements OnInit {

  private _networkIf: NetworkInterface;

  @Input()
  featureLevel = false;

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<NetworkInterface>();

  @Input()
  get networkIf(): NetworkInterface {
    return this._networkIf;
  }

  set networkIf(value: NetworkInterface) {
    this._networkIf = value;
    if (!isNullOrUndefined(this._networkIf)) {
      this.form.patchValue(this._networkIf);
      this.selectedRouteType = this._networkIf.route_type;
    } else {
      this.selectedRouteType = null;
    }
  }

  labels = {
    name: 'Name',
    configserver: 'Configserver',
    ip_address: 'IP Address',
    no_loc_offset: "No Location id offset",
    increment_ip_address: "Increment IP address",
    alias: 'Alias',
    netmask: 'Netmask',
    gateway: 'Gateway',
    route_type: 'Route',
    route_dest: 'Route Dest',
    route_gateway: 'Route Gateway',
    route_netmask: 'Route Netmask',
    additional_ggw_if: 'Additional GGW Interface'
  };

  configserverOptions = [
    {value: 'yes', label: 'Yes'},
    {value: 'no', label: 'No'},
  ];

  noLocOffsetOptions = [
    {value: 'yes', label: 'True'},
    {value: null, label: 'False'},
  ];

  routeTypeOptions = [
    {value: null, label: ''},
    {value: 'net', label: 'net'},
  ];

  unitUri: string;
  selectedRouteType = null;
  form: FormGroup;
  styleType = StyleType;

  constructor(private formBuilder: FormBuilder,
              private genericResourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private notification: NotificationsService,
              private networkIfService: NetworkInterfaceService,
              private featureNetworkIfService: FeatureNetworkInterfaceService) {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      configserver: ['', [Validators.required]],
      ip_address: ['', [Validators.required]],
      no_loc_offset: ['', []],
      increment_ip_address: ['', []],
      alias: ['', []],
      netmask: ['', [Validators.required]],
      gateway: ['', []],
      route_type: ['', []],
      route_dest: ['', []],
      route_gateway: ['', []],
      route_netmask: ['', []],
      additional_ggw_if: ['', []],
    });
  }

  ngOnInit() {
  }

  get dataIsReady() {
    return !isNullOrUndefined(this._networkIf);
  }

  saveNetworkIf() {
    if (this._networkIf) {
      const networkIfService = this.genericResourceService.findServiceForResource(this._networkIf._links.self.href);
      let item = this.form.value;
      item.id = this._networkIf.id;
      networkIfService.save(item).subscribe((result) => {
        this.notification.success('Network interface updated', 'The network interface was successfully updated.');
        this.afterUpdate.emit(result as NetworkInterface);
        this.activeModal.close();
      });
    } else {
      // Create new
      let item = this.form.value;
      item.unit = this.unitUri;
      let createService: any = this.networkIfService;
      if (this.featureLevel) {
        createService = this.featureNetworkIfService;
      }
      createService.create(item).subscribe((result) => {
        this.notification.success('Network interface created', 'The network interface was successfully created.');
        this.afterUpdate.emit(result as NetworkInterface);
        this.activeModal.close();
      });
    }
  }

  changeRouteType(event) {
    this.selectedRouteType = event.value;
  }

  deleteNetworkIf() {
    const confirmDelete = confirm('Are you sure you want to delete this network interface?');
    if (confirmDelete) {
      const networkIfService = this.genericResourceService.findServiceForResource(this._networkIf._links.self.href);
      networkIfService
        .delete()
        .subscribe(() => {
          this.notification.success('Network interface deleted', 'The network interface was successfully removed.');
          this.afterDelete.emit();
          this.activeModal.close();
        });
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/network-interfaces/components/modify-network-if/modify-network-if.component.ts